<template>
  <KPICard :title="'Points Earned'">
    <div class="row align-items-center">
      <div class="col">
        <h6 class="card-title text-uppercase text-muted mb-2">Points Earned</h6>
        <span class="h2 mb-0">{{ totalPointsEarned }}</span>
      </div>
      <div class="col-auto">
        <span class="h2 fe fe-gift text-muted mb-0"></span>
      </div>
    </div>
  </KPICard>
</template>

<script>
import KPICard from '@/components/Cards/KPICard'

export default {
  name: 'TotalPointsEarnedCard',
  props: ['totalPointsEarned'],
  components: {
    KPICard
  }
}
</script>

<style scoped lang="scss"></style>
